import { useState, useEffect, useCallback } from "@wordpress/element";
import {
	PREMIUM_FEATURES_MAP,
	PREMIUM_FEATURE_LABELS,
} from "@/constant/premium-features";

// Marketplace build: license always valid & activated; all premium features available.
const DEFAULT_LICENSE_STATE = {
	isValid: true,
	isActivated: true,
	licenseKey: "MARKETPLACE-BUILD",
	licenseData: {
		license: "valid",
		item_name: "Marketplace Build (All Features Unlocked)",
		expires: "lifetime",
	},
	premiumFeatures: PREMIUM_FEATURE_LABELS,
	isLoading: false,
	error: null,
};

// Cleanup logic no longer required in marketplace build – retained as no-op.
const cleanupPremiumFeatures = () => {};

export default function useLicense() {
	const [licenseState] = useState(DEFAULT_LICENSE_STATE);
	const [initialLoadComplete, setInitialLoadComplete] = useState(false);

	// Immediately mark load complete (no async calls needed)
	useEffect(() => {
		setInitialLoadComplete(true);
	}, []);

	const hasFeature = useCallback(
		(label) => licenseState.premiumFeatures.includes(label),
		[licenseState.premiumFeatures],
	);

	const canActivateFeature = useCallback(() => true, []);

	const activateLicense = useCallback(() => true, []);
	const deactivateLicense = useCallback(() => true, []);
	const checkLicense = useCallback(() => true, []);

	return {
		...licenseState,
		activateLicense,
		deactivateLicense,
		checkLicense,
		hasFeature,
		canActivateFeature,
		cleanupPremiumFeatures,
		PREMIUM_FEATURES: PREMIUM_FEATURES_MAP,
		initialLoadComplete,
	};
}
